//
//
//
//
//

import { mapActions } from 'vuex';

export default {
  name: 'Logout',
  data() {
    return {};
  },
  methods: {
    ...mapActions('user', ['logout']),
  },
  mounted() {
    this.$router.replace('/');
    this.logout('userClick');
  },
};
